function CustomApplicationsCtrl($scope, $timeout, $state, $controller, GeneralUtilsService, RulesService) {

	$controller('ConfigController', {$scope: $scope, $timeout: $timeout});

	$scope.tableConfig = {
	    hasChanges: $scope.$root.hasChanges,
		noAutoCheckboxSelect: true,
		mode: 'list',
		accountId : $state.params.accountId,
		dataURL : function() {
			return "/getAllCustomApps?accountId=" + ($state.params.accountId? $state.params.accountId : "");
		},
		titleSearch: 'Custom App',
		height: $scope.getContentHeight(),
		pageSize: 50,
		afterUpdate: function(){
	    	if ($scope.tableConfig.items.length === 0){
				$scope.showApp(null)
			}
			if(!$scope.loaded){
				return;
			}
			if($scope.$root){
				$scope.$root.updateScroll('.pane.left .nano');
			}
		},
		searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
		sortButton: true,
		fields : [
			{"label":"Name","path":"name"},
			{"label":"Description","path":"description"},
			{"label":"Creation Date","path":"creationDate"},
			{"label":"Last Modified","path":"lastModified"},
		],
		type : "CustomApplication",
		addAction : function(type) {
			$scope.newApp = {id:GeneralUtilsService.getRandomId(),"name":"", categoriesIds: []};
			$scope.$root.openPopup('addAppDlg');
		},
		actions: ["remove"],
		onSelect: function(index) {
			$scope.selectedAppIndex = index;
			$scope.showApp($scope.tableConfig.items[index]);
		}
	};

	$scope.addApp = function(newApp) {
		var params = {'accountId': $state.params.accountId,'type':'CustomApplication','save':true};
		$scope.loadingSaveNew = true;
		store.save({
			path: "/add",
			data: $scope.newApp,
			dataObj: 'json',
			queryParams: params,
			success: function(data) {
				$scope.loadingSaveNew = false;
				$scope.$root.handleServerResponse(data,"newApp", "Application added successfully");
				if(data.status !== "ERROR"){
					$scope.tableConfig.selectedId = data.model.id;
					$scope.datamodified = new Date().getTime();
					$scope.$root.closePopup('addAppDlg');
				}
			}
		});
	};


	$scope.definitionsConfig = {
		id: 'definitions',
		dataURL : function() {
			if (!$scope.app) {
				return;
			}

			return "/getCustomAppDefinitions?customapplicationId=" + $scope.app.id;
		},
		pageSize: -1,
		clientSideSearch: true,
		clientSideSort: true,
		processData: function(items) {
			items.forEach(function (item) {
				var tlds = item.topLevelDomains? item.topLevelDomains.join(', ') : '';
				var fqdns = item.fqdns? item.fqdns.join(', ') : '';
				item.domains = (tlds !== '' && fqdns !== '')? (tlds + ', ' + fqdns) : (tlds + fqdns);
			});
			$scope.origDefinitions = angular.copy(items);
		},
		actions: [],
		titleSearch: 'Definitions',
		protocols: ['TCP', 'UDP', 'ICMP'],
		fields: [
			{label: 'Protocol', path: 'protocol', template: '<select ng-options="protocol for protocol in tableConfig.protocols" ng-model="item.protocol"></select>'},
			{label: 'Ports', path: 'ports', template: '<div ng-disabled="item.protocol === \'ICMP\'"  style="overflow: hidden;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 300px">{{item.ports}}</div><span class="edit-button" ng-click="tableConfig.editDefinition(item, \'ports\', item.id)" id="edit_ports_{{item.id}}">Edit</span>'},
			{label: 'Destination IPs', path: 'ips', template: '<div  style="overflow: hidden;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 300px">{{item.ips}}</div>  <span class="edit-button"  ng-click="tableConfig.editDefinition(item, \'ips\', item.id)" id="edit_ips_{{item.id}}">Edit</span>'},
			{label: 'Domains', path: 'domains', template: '<div  style="overflow: hidden;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 300px"a>{{item.domains}}</div> <span class="edit-button" ng-click="tableConfig.editDefinition(item, \'domains\', item.id)" id="edit_domains_{{item.id}}">Edit</span>'},
		],
		specialActions: [
			{
				'icon': 'add',
				'tooltip':'Add',
				'func':  function(selectedItems, tableConfig) {
					var randomId = Math.floor((Math.random() * 100000000000000) + 1);
					if(!$scope.definitionsConfig.items){
						$scope.definitionsConfig.items = [];
					}

					$scope.definitionsConfig.items.unshift({id:randomId * -1, protocol: ' '});
					tableConfig.refreshViewItems = new Date().getTime();
				}
			},
			{
				'icon':'delete',
				'tooltip':'Delete',
				'func' : function(selectedItems, tableConfig) {
					if (selectedItems) {
						selectedItems.forEach(function (item) {
							$scope.definitionsConfig.items.splice($scope.definitionsConfig.items.indexOf(item),1);
						});

						$scope.definitionsConfig.selectedItems = [];
					}
					tableConfig.refreshViewItems = new Date().getTime();
				}
			},
		],
		editDefinition: function (item, type, id) {
			$scope.closeSelectionPopups();
			$scope.currDefinition = item;
			$scope.currDefinitionCopy = angular.copy($scope.currDefinition);
			if ($scope.currDefinitionCopy.fqdns) {
				$scope.currDefinitionCopy.fqdns = $scope.currDefinitionCopy.fqdns.join(",")
			} else {
				$scope.currDefinitionCopy.fqdns = '';
			}

			if ($scope.currDefinitionCopy.topLevelDomains) {
				$scope.currDefinitionCopy.topLevelDomains = $scope.currDefinitionCopy.topLevelDomains.join(",");
			} else {
				$scope.currDefinitionCopy.topLevelDomains = '';
			}
			$scope.currDefinitionCopy.domains = $scope.currDefinitionCopy.fqdns ? ($scope.currDefinitionCopy.fqdns + ',' + $scope.currDefinitionCopy.topLevelDomains) : $scope.currDefinitionCopy.topLevelDomains;
			$scope.$root.$emit('$openPopup', type + '-selection-popup', 'edit_' + type + '_' + id);
		},
	};

	$scope.removeDefinitions = function (items) {

	};

	$scope.showApp = function (app) {
		$timeout(function () {
			$scope.app = app;
			$scope.orig = angular.copy($scope.app);
			$scope.definitionsRefresh = new Date().getTime();
		}, 0);
	};

	$scope.saveDefinitionChanges = function (type) {
		if (type === 'domains') {
			$scope.currDefinition.fqdns = $scope.currDefinitionCopy.fqdns ? $scope.currDefinitionCopy.fqdns.split(',') : [];
			$scope.currDefinition.topLevelDomains = $scope.currDefinitionCopy.topLevelDomains ? $scope.currDefinitionCopy.topLevelDomains.split(',') : [];
			var tlds = $scope.currDefinition.topLevelDomains? $scope.currDefinition.topLevelDomains.join(', ') : '';
			var fqdns = $scope.currDefinition.fqdns? $scope.currDefinition.fqdns.join(', ') : '';
			$scope.currDefinition.domains = (tlds !== '' && fqdns !== '')? (tlds + ', ' + fqdns) : (tlds + fqdns);
			//$scope.currDefinition.domains = $scope.currDefinitionCopy.fqdns.concat($scope.currDefinitionCopy.topLevelDomains);
		} else {
			$scope.currDefinition[type] = $scope.currDefinitionCopy[type];
		}

		$scope.$root.$emit('$closePopup', type + '-selection-popup');
	};

	$scope.closeSelectionPopups = function() {
		$scope.$root.$emit('$closePopup', 'ports-selection-popup');
		$scope.$root.$emit('$closePopup', 'ips-selection-popup');
		$scope.$root.$emit('$closePopup', 'domains-selection-popup');
	};

	$scope.saveChanges = function () {
		$scope.loading = true;
		var params = {'customapplicationId':$scope.app.id,'save':true, newSaveMethod: true, 'accountId': $state.params.accountId};

		if ($scope.definitionsConfig.items) {
			$scope.definitionsConfig.items.forEach(function(definition) {
				if(definition.protocol === 'ICMP') {
					definition.ports = '';
				}
			})
		}
		$scope.app.newSaveMethod = true;
		$scope.app.definitions = $scope.definitionsConfig.items;

		store.save({
			path: "/edit",
			data: $scope.app,
			dataObj: 'json',
			queryParams: params,
			success: function(data) {
				$scope.loading = false;
				$scope.$root.handleServerResponse(data, "app", "Application saved successfully");
				if(data.status !== "ERROR"){
					$scope.showApp(data.model, true);
				}
			}
		});
	};

	$scope.$root.hasChanges = function(){
		var app = $scope.app;
		if(!app) return false;
		if(app.id < 0) return true; //new app
		if(!angular.equals($scope.app,$scope.orig)) return true;
		if(!angular.equals($scope.definitionsConfig.items, $scope.origDefinitions)) return true;
		return false;
	};

	store.fetch({
		queryParams: {accountId: $state.params.accountId},
		path: '/getAllCategories',
		success: function(data) {
			$scope.categories = data;
		}
	});


	$scope.addServiceConfig = RulesService.getServicesConfig($state.params.accountId);


	$scope.itemsEntryListSelect = function (id, item) {
		$scope.showWhatItems = 'categories';

		initiateAddServiceConfigProperties();

		/*
		 * this section is responsible for filling the
		 * addServiceConfig properties after we initiated them in
		 * initiateAddServiceConfigProperties
		 */
		item.categories.forEach(function(service){
			if(!service.ip){
				if(service.type === 'AppCategory'){
					// Category
					$scope.addServiceConfig.categoriesConfig.selectedItems.push(service);
				}
			}
		});

		$scope.currentItem = item;
		$scope.$root.openPopup('categoriesServicesDlg');
	};

	function initiateAddServiceConfigProperties() {
		// when opening the dialog - check all existing items
		$scope.addServiceConfig.categoriesConfig.selectedItems = [];
	}

	$scope.addItems = function() {
		var currentWhat = $scope.app.categories;
		currentWhat.length = 0;

		fillCategoryConfig(currentWhat);

		$scope.$root.closePopup('categoriesServicesDlg');
	};

	/**
	 * method for filling the app config
	 * @param currentWhat
	 */
	function fillCategoryConfig(currentWhat) {
		// Apps
		$scope.addServiceConfig.categoriesConfig.selectedItems.forEach(function (category) {
			if (currentWhat.indexOf(category) < 0) {
				category.type = "AppCategory";
				currentWhat.push(category);
			}
		});
	}

}
